import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ivd-cro")({
  head: () => buildRouteHead("/ivd-cro", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/clinical-solutions/ivd-clinical-performance-studies", replace: true });
  },
});
